import { initCarsFilters } from "./filters.js";
import { initCarsSearch } from "./search.js";
import { initCarsClear } from "./clear.js";

function boot() {
  initCarsFilters();
  initCarsSearch();
  initCarsClear();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}